import React from 'react';
import { Plus, X } from 'lucide-react';

const ServiceSchemaForm = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const handleServiceAdd = () => {
    const services = data?.services || [];
    services?.push({
      '@type': 'Offer',
      name: '',
      description: '',
      price: '',
      priceCurrency: 'USD'
    });
    handleChange('services', services);
  };

  const handleServiceRemove = (index) => {
    const services = [...(data?.services || [])];
    services?.splice(index, 1);
    handleChange('services', services);
  };

  const handleServiceChange = (index, field, value) => {
    const services = [...(data?.services || [])];
    services[index] = { ...services?.[index], [field]: value };
    handleChange('services', services);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Service Type <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data?.serviceType || ''}
            onChange={(e) => handleChange('serviceType', e?.target?.value)}
            placeholder="Bail Bond Services"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Area Served
          </label>
          <input
            type="text"
            value={data?.areaServed || ''}
            onChange={(e) => handleChange('areaServed', e?.target?.value)}
            placeholder="Sacramento County, Placer County, El Dorado County"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
          />
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">Service Offerings</h3>
          <button
            type="button"
            onClick={handleServiceAdd}
            className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add Service
          </button>
        </div>

        {(data?.services || [])?.map((service, index) => (
          <div key={index} className="p-4 border border-gray-200 rounded-lg space-y-4">
            <div className="flex items-center justify-between mb-4">
              <h4 className="font-medium text-gray-900">Service {index + 1}</h4>
              <button
                type="button"
                onClick={() => handleServiceRemove(index)}
                className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Service Name
                </label>
                <input
                  type="text"
                  value={service?.name || ''}
                  onChange={(e) => handleServiceChange(index, 'name', e?.target?.value)}
                  placeholder="24/7 Bail Bond Service"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  value={service?.description || ''}
                  onChange={(e) => handleServiceChange(index, 'description', e?.target?.value)}
                  placeholder="Fast, professional bail bond service available 24/7"
                  rows={3}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Price
                </label>
                <input
                  type="text"
                  value={service?.price || ''}
                  onChange={(e) => handleServiceChange(index, 'price', e?.target?.value)}
                  placeholder="10% of bail amount"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Currency
                </label>
                <select
                  value={service?.priceCurrency || 'USD'}
                  onChange={(e) => handleServiceChange(index, 'priceCurrency', e?.target?.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                >
                  <option value="USD">USD - US Dollar</option>
                </select>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
        <p className="text-sm text-green-800">
          <strong>Tip:</strong> Add multiple service offerings to provide comprehensive information about your bail bond services, payment plans, and specialized options.
        </p>
      </div>
    </div>
  );
};

export default ServiceSchemaForm;